var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`alert-${_vm.alertType}`},[(_vm.classIcon)?_c('span',{class:_vm.classIcon}):_vm._e(),_c('span',{class:`alert-${_vm.alertType}-message`},[_vm._v(" "+_vm._s(_vm.message)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }